import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { PaqueteSeguros } from '../../_models/paquete-seguros';
import { PaqueteSegurosService } from '../../_services/paquete-seguros.service';
import {Alerta} from '../../_models/alerta';
import {GarantiasIdoneas} from '../../_models/garantias-idoneas';
import {GarantiaIdoneasService} from '../../_services/garantia-idoneas.service';
import {ConfiguracionesCanales} from '../../_models/configuraciones-canales';
import {ConfiguracionesCanalesService} from '../../_services/configuraciones-canales.service';

@Component( {
  selector: 'app-configuracion-canal-estado-listado',
  templateUrl: 'configuracion-canal-estado-listado.component.html'
} )

export class ConfiguracionCanalEstadoListadoComponent implements OnInit {

  conCanales: ConfiguracionesCanales[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  mosDetalle = false;
  canalSeleccionada: ConfiguracionesCanales;

  constructor( private configuracionCanalServicio: ConfiguracionesCanalesService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/configuracion-canal-estado' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'canal', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_CANAL' ), sort: true },
      { field: 'estado', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_ESTADO' ), sort: true },
      { field: 'seccion', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_SECCION' ), sort: true },
      { field: 'control', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_CONTROL' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'configuracion-canal-estado.component' );

    this.configuracionCanalServicio.listado().subscribe( canales => {
      this.conCanales = canales;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );

    this.carTabla = false;
  }


  crear() {
    this.router.navigate( [ 'apl/configuracion-canal-estado/agregar' ] );
  }

  ver( palClave: ConfiguracionesCanales ) {
    this.router.navigate( [ 'apl/configuracion-canal-estado/detalle/' + palClave.idConfiguracionCanal ] );
  }

  editar( palClave: ConfiguracionesCanales ) {
    this.router.navigate( [ 'apl/configuracion-canal-estado/actualizar/' + palClave.idConfiguracionCanal ] );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'configuracion-canal-estado.component', this.busqueda );
  }

  cerrar() {
    this.mosDetalle = false;
  }


}
